import React, { useState, useContext, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../comum/Context/auth.jsx";
import { api } from "../../services/api.js";

import { setLoginToday } from "./../Utils/auth.js";

import logoSmall from "../../comum/assets/arbor.png";
import Menu from "../../comum/Menu/index.jsx";
import Footer from "../../comum/Footer/index.jsx";
import SentimentoPopup from "../Components/Sentimento/SentimentoPopup.jsx";

import "./index.css";

function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  const senhaRef = useRef(null); // 🔹 referência para campo senha
  const inputRef = useRef(null);

  const { setLogado } = useContext(AuthContext);

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [msgerro, setmsgErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [mostrarSentimento, setMostrarSentimento] = useState(false);

  const [cacheForcado, setCacheForcado] = useState(false);

  const [chapaUsuario, setChapaUsuario] = useState(null);
  const [eyesIsClosed, setEyeState] = useState(false);

  const emailRef = useRef(null); // 🔹 referência para o campo de matrícula

  useEffect(() => {
    emailRef.current?.focus(); // 🔹 foca no input assim que a página carregar
  }, []);


  const redirectTo =
    new URLSearchParams(location.search).get("redirect") || "/arbor/home";

  const toggleShow = () => {
    if (inputRef.current) {
      const isPassword = inputRef.current.type === "password";
      inputRef.current.type = isPassword ? "text" : "password";
      setEyeState(!isPassword);
    }
  };

  const LoginArbor = () => {
    setLogado(false);
    localStorage.clear();
    const data = { usuario: email, senha, versao: "1.2" };

    api
      .post("/usuario/consultausuario/web", data)
      .then((retorno) => {
        const res = retorno.data;
        setSucesso(res.SUCESSO);
        setmsgErro(res.ERRO);
       
        if (res.SUCESSO === "S") {
          // validação do PONTO
          const temPermissaoPonto = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "RHEXCLUSIVO" &&
              p.usrconf_campo === "RHEXVPONTOAUTORIZA" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("permitePonto", temPermissaoPonto ? "S" : "N");

          const temPermissaoRegional = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "RHEXCLUSIVO" &&
              p.usrconf_campo === "RHEXVCOMUNICADOREG" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("permiteRegional", temPermissaoRegional ? "S" : "N");

          const temPermissaoSap = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "SAP" &&
              p.usrconf_campo === "SAPADMIN" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("SAPADM", temPermissaoSap ? "S" : "N");

          //checklist TI
          const temCadastroCheckListti = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "TICHECKCADASTRO" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("TICADCHECKLIST", temCadastroCheckListti ? "S" : "N");


          //DashBoard RH
          const permiteDashBoardRH = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "FLOSOFTNEW" &&
              p.usrconf_campo === "RH" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("RHDASHBOARD", permiteDashBoardRH ? "S" : "N");
          

          const temCheckList = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "CHECKLIST" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("CHECKLIST", temCheckList ? "S" : "N");
          // 🔹 Montagem das lojas permitidas
          let lojasPermitidas = res.LOJAS || [];

          const permiteVendas = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "VENDAS" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("permiteVendas", permiteVendas ? "S" : "N");

          const lojaPri = res.PROGRAMAS?.find(
            (p) =>
              p.usrconf_modulo === "USRLOJA" &&
              p.usrconf_campo === "NUMLOJA"
          );
          // O 'lojaPri?.usrconf_acesso' garante que só tentará acessar 'usrconf_acesso' se 'lojaPri' não for nulo/indefinido
          if (lojaPri?.usrconf_acesso) {
            localStorage.setItem("lojaprincipal", lojaPri.usrconf_acesso);
            console.log("loja Pri: " + lojaPri.usrconf_acesso);
          } else {
            // Adicione um log ou tratamento para quando não encontrar a loja principal
            console.log("Erro: Loja principal (lojaPri) não foi encontrada ou não possui 'usrconf_acesso'.");
            // Você pode querer definir um valor padrão ou tratar o erro aqui
          }

          // Se não houver LOJAS, buscar em PROGRAMAS
          if (
            (!lojasPermitidas || lojasPermitidas.length === 0) &&
            res.PROGRAMAS
          ) {
            const lojaPrincipal = res.PROGRAMAS.find(
              (p) =>
                p.usrconf_modulo === "USRLOJA" &&
                p.usrconf_campo === "NUMLOJA"
            );
            if (lojaPrincipal) {
              lojasPermitidas = [parseInt(lojaPrincipal.usrconf_acesso, 10)];
            }
          }
          // 🔹 Normaliza lojas -> sempre com 2 dígitos e ordenadas
          lojasPermitidas = lojasPermitidas
            .map((l) => String(l).padStart(2, "0"))
            .sort((a, b) => parseInt(a) - parseInt(b));

          localStorage.setItem(
            "lojasPermitidas",
            JSON.stringify(lojasPermitidas)
          );

          // define loja selecionada (a principal)
          const lojaSelecionada = res.LOJA
            ? String(res.LOJA).padStart(2, "0")
            : lojasPermitidas[0] || null;
          localStorage.setItem("lojaSelecionada", lojaSelecionada);

          localStorage.setItem(
            "pontoAutorizado",
            temPermissaoPonto ? "S" : "N"
          );

          // 🔹 Salvar apenas dados essenciais do usuário
          /*const usuarioInfo = {
            usuario: res.USUARIO,
            nome: res.NOME,
            lojaSelecionada,
            lojasPermitidas,
            permitePonto: temPermissaoPonto ? "S" : "N",
            sapAdm: temPermissaoSap ? "S" : "N",
          };
          localStorage.setItem("usuarioInfo", JSON.stringify(usuarioInfo));*/
          localStorage.setItem("usuarioInfo", JSON.stringify(res));

          // 🔹 Restante do fluxo
          setLoginToday(data.usuario, lojaSelecionada, res.SAP, null);
          localStorage.removeItem("codigorest");
          setChapaUsuario(data.usuario);
          setLogado(true);
          

          localStorage.setItem("sentido", res.SENTIMENTO);
          localStorage.setItem("msg", res.MENSAGENS);
          if (res.SENTIMENTO === "0") {
            setMostrarSentimento(true);
          }
        } else {
          localStorage.setItem("logado", "N");
          localStorage.setItem("acessoSAP", "N");
          setLogado(false);
        }
      })
      .catch((err) => {
        console.error("Erro de login:", err);
        localStorage.setItem("logado", "N");
        localStorage.setItem("acessoSAP", "N");
        setLogado(false);
        setSucesso("N");
        setmsgErro("Erro de comunicação com o servidor");
      });
  };

  useEffect(() => {
    if (sucesso === "S" && !mostrarSentimento) {
      if (chapaUsuario?.startsWith("900010")) {
        navigate("/arbor/home/");
      } else if (chapaUsuario?.startsWith("900001")) {
        navigate("/arbor/home/");
      } else if (chapaUsuario?.startsWith("90")) {
        navigate("/arbor/restaurante/");
      } else {
        navigate("/arbor/home/");
      }
    }
  }, [sucesso, mostrarSentimento, redirectTo, navigate, chapaUsuario]);

  return (
    <div>
      <Menu modulo="login" />

      <div className="d-flex align-items-center text-center form-container">
        <form className="form-signin" onSubmit={(e) => e.preventDefault()}>
          <img className="mb-4 img-login" src={logoSmall} alt="Arbor" />
          <h1 className="h3 mb-3 fw-normal">Login</h1>

          <div className="form-floating">
            <input
              type="number"
              id="floatingInput"
              className="form-control"
              placeholder="Matrícula"
              value={email}
              ref={emailRef}               // 🔹 aplica a ref
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  senhaRef.current?.focus(); // 🔹 foca no campo senha
                }
              }}
            />
            <label htmlFor="floatingInput">Matrícula</label>
          </div>

          <div className="form-floating">
            <input
              type="password"
              id="floatingPassword"
              className="form-control"
              placeholder="Senha"
              ref={senhaRef} // 🔹 referência do campo senha
              onChange={(e) => setSenha(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && email !== "") {
                  e.preventDefault();
                  LoginArbor();
                }
              }}
            />
            <label htmlFor="floatingPassword">Senha</label>
          </div>

          <button
            type="button"
            className="w-100 btn btn-lg btn-success"
            onClick={LoginArbor}
          >
            Acessar
          </button>

          {sucesso === "N" && (
            <div className="alert alert-danger mt-2" role="alert">
              {msgerro}.
            </div>
          )}

          <p className="mt-5 mb-3 text-muted">
            &copy; Desenvolvido por F2 Enterprise
          </p>
        </form>
      </div>

      {mostrarSentimento && (
        <SentimentoPopup
          chapa={chapaUsuario}
          onClose={() => setMostrarSentimento(false)}
        />
      )}

      <Footer />
    </div>
  );
}

export default Login;
